import * as _ from 'lodash';
import toastr from 'toastr';
import apiService from '../../../service/apiService';
import * as Utility from '../../../HelperMethods/UtilityFunctions';
import {
  VENDOR_VARIABLE_NAME,
  SKILLLEVEL_VARIABLE_NAME,
  CERTIFICATES_VARIABLE_NAME,
  ACLQUALIFIED_VARIABLE_NAME,
} from '../../../HelperMethods/constants';
import * as constants from '../../../HelperMethods/constants';
import { getPickListOptions } from '../../../HelperMethods/UtilityFunctions';
import { getUsersApi } from '../../../HelperMethods/apiHelper';
import logUtils from '../../../HelperMethods/LogUtils';
// eslint-disable-next-line import/no-cycle
import {
  // setLoader,
  setUserList,
  setGridParam,
  setIsExporting,
} from './reducer';

const component = 'USER_MANAGEMENT_PAGE';

export const types = {
  SET_LOADER: `${component}_SET_LOADER`,
  SET_USER_LIST: `${component}_SET_USER_LIST`,
  SET_GRID_PARAM: `${component}_SET_GRID_PARAM`,
  LOADING: `${component}_LOADING`,
  LOADED: `${component}_LOADED`,
  LOADING_USERS_AT_FIELD_LEVEL: `${component}_LOADING_USERS_AT_FIELD_LEVEL`,
  TEAM_LIST_LOADING_START: `${component}TEAM_LIST_LOADING_START`,
  TEAM_LIST_LOADING_DONE: `${component}TEAM_LIST_LOADING_DONE`,
  TEAM_LIST_LOADING_STOP: `${component}TEAM_LIST_LOADING_STOP`,
  AREA_LIST_LOADING_START: `${component}AREA_LIST_LOADING_START`,
  AREA_LIST_LOADING_DONE: `${component}AREA_LIST_LOADING_DONE`,
  AREA_LIST_LOADING_STOP: `${component}AREA_LIST_LOADING_STOP`,
  LOAD_USERS_AT_FIELD_LEVEL_SUCCESS: `${component}_LOAD_USERS_AT_FIELD_LEVEL_SUCCESS`,
  LOAD_USERS_AT_FIELD_LEVEL_FAILED: `${component}_LOAD_USERS_AT_FIELD_LEVEL_FAILED`,
  UPDATING_USER: `${component}_UPDATING_USER`,
  LOADING_EDIT_USER: `${component}_LOADING_EDIT_USER`,
  EDIT_USER_LOAD_FAILED: `${component}_EDIT_USER_LOAD_FAILED`,
  EDIT_USER_LOAD_SUCCESS: `${component}_EDIT_USER_LOAD_SUCCESS`,
  UPDATE_USER_SUCCESS: `${component}_UPDATE_USER_SUCCESS`,
  USER_UPDATE_INFO: `${component}_USER_UPDATE_INFO`,
  CLEAR_EDIT_USER_INFO: `${component}_CLEAR_EDIT_USER_INFO`,
  DELETE_USER_SUCCESS: `${component}_DELETE_USER_SUCCESS`,
  UPDATE_USER_FAILED: `${component}_UPDATE_USER_FAILED`,
  CREATE_USER_SUCCESS: `${component}_CREATE_USER_SUCCESS`,
  BULK_CREATING_USER: `${component}_BULK_CREATING_USER`,
  RETURN_TASK_EDIT_PAGE_STATE: `${component}_RETURN_TASK_EDIT_PAGE_STATE`,
  REDIRECT_LINK_STATE_CHANGE: `${component}_REDIRECT_LINK_STATE_CHANGE`,
  RETURN_TASK_PAGE_STATE: `${component}_RETURN_TASK_PAGE_STATE`,
  BULK_CHECK_USER_SUCCESS: `${component}_BULK_CHECK_USER_SUCCESS`,
  BULK_CREATE_USER_SUCCESS: `${component}_BULK_CREATE_USER_SUCCESS`,
  BULK_CREATE_USER_FAILED: `${component}_BULK_CREATE_USER_FAILED`,
  REDIRECT_LINK_STATE_TO_TRUE: `${component}_REDIRECT_LINK_STATE_TO_TRUE`,
  UPDATE_FIELDLIST_USERMANGEMENT: `${component}_UPDATE_FIELDLIST_USERMANGEMENT`,
  REDIRECT_LINK_STATE_RESET: `${component}_REDIRECT_LINK_STATE_RESET`,
  LOADING_STATE_INACTIVE: `${component}_LOADING_STATE_INACTIVE`,
  LOADING_STATE_ACTIVE: `${component}_LOADING_STATE_ACTIVE`,
  EDIT_PAGE_LOADER_STATE: `${component}_EDIT_PAGE_LOADER_STATE`,
  ON_FIELD_CHANGE: `${component}_ON_FIELD_CHANGE`,

  [`LOADING_${VENDOR_VARIABLE_NAME}_PICKLIST`]: `${component}_LOADING_${VENDOR_VARIABLE_NAME}_PICKLIST`,
  [`LOAD_${VENDOR_VARIABLE_NAME}_PICKLIST_SUCCESSFUL`]: `${component}_LOAD_${VENDOR_VARIABLE_NAME}_PICKLIST_SUCCESSFUL`,
  [`LOAD_${VENDOR_VARIABLE_NAME}_PICKLIST_FAILED`]: `${component}_LOAD_${VENDOR_VARIABLE_NAME}_PICKLIST_FAILED`,
  [`LOADING_${CERTIFICATES_VARIABLE_NAME}_PICKLIST`]: `${component}_LOADING_${CERTIFICATES_VARIABLE_NAME}_PICKLIST`,
  [`LOAD_${CERTIFICATES_VARIABLE_NAME}_PICKLIST_SUCCESSFUL`]: `${component}_LOAD_${CERTIFICATES_VARIABLE_NAME}_PICKLIST_SUCCESSFUL`,
  [`LOAD_${CERTIFICATES_VARIABLE_NAME}_PICKLIST_FAILED`]: `${component}_LOAD_${CERTIFICATES_VARIABLE_NAME}_PICKLIST_FAILED`,
  [`LOADING_${SKILLLEVEL_VARIABLE_NAME}_PICKLIST`]: `${component}_LOADING_${SKILLLEVEL_VARIABLE_NAME}_PICKLIST`,
  [`LOAD_${SKILLLEVEL_VARIABLE_NAME}_PICKLIST_SUCCESSFUL`]: `${component}_LOAD_${SKILLLEVEL_VARIABLE_NAME}_PICKLIST_SUCCESSFUL`,
  [`LOAD_${SKILLLEVEL_VARIABLE_NAME}_PICKLIST_FAILED`]: `${component}_LOAD_${SKILLLEVEL_VARIABLE_NAME}_PICKLIST_FAILED`,
  [`LOADING_${ACLQUALIFIED_VARIABLE_NAME}_PICKLIST`]: `${component}_LOADING_${ACLQUALIFIED_VARIABLE_NAME}_PICKLIST`,
  [`LOAD_${ACLQUALIFIED_VARIABLE_NAME}_PICKLIST_SUCCESSFUL`]: `${component}_LOAD_${ACLQUALIFIED_VARIABLE_NAME}_PICKLIST_SUCCESSFUL`,
  [`LOAD_${ACLQUALIFIED_VARIABLE_NAME}_PICKLIST_FAILED`]: `${component}_LOAD_${ACLQUALIFIED_VARIABLE_NAME}_PICKLIST_FAILED`,
  LOAD_USERS_SUBSCRIPTION_SUCCESS: `LOAD_USERS_SUBSCRIPTION_SUCCESS`,
  SET_EXPORTING: `${component}_SET_EXPORTING`,
};

export function editPagesetLoader(loaderState) {
  return async (dispatch) => {
    dispatch({ type: types.EDIT_PAGE_LOADER_STATE, loaderState });
  };
}

export function loadEditUserInfo(id) {
  return async (dispatch) => {
    dispatch({ type: types.LOADING_EDIT_USER });
    try {
      const response = await apiService.getUsersByIDs([id]);

      const editUser = _.get(response, 'data.getUserByIds')[0];
      if (!editUser) throw new Error('User not found');
      dispatch({ type: types.EDIT_USER_LOAD_SUCCESS, userEdit: editUser });
    } catch (e) {
      logUtils.logError(e, 'User not found');
      dispatch({ type: types.EDIT_USER_LOAD_FAILED });
      throw e;
    }
  };
}

export function redirectUserActionTrue() {
  return (dispatch) => {
    dispatch({ type: types.RETURN_TASK_PAGE_STATE });
  };
}

export function redirectUserAction() {
  return (dispatch) => {
    dispatch({ type: types.REDIRECT_LINK_STATE_RESET });
  };
}

export function setIsPageLoading() {
  return (dispatch) => {
    dispatch({ type: types.LOADING });
  };
}

export function setIsPageLoaded() {
  return (dispatch) => {
    dispatch({ type: types.LOADED });
  };
}

export function getAssetbyIds(assetIds) {
  let output = null;
  return async () => {
    try {
      // dispatch({ type: types.ASSET_LOADING });
      if (_.isArray(assetIds)) {
        output = await apiService.getAssetsByIds(assetIds);
      } else {
        output = await apiService.getAssetsByIds([assetIds]);
      }

      if (!output) throw new Error('Asset fetch failed');
    } catch (error) {
      // dispatch({ type: types.ASSET_LOAD_FAILED });

      logUtils.logError(error, 'Assets Fetching failed');
    }
    return output;
  };
}

export function deleteRole(user) {
  return async (dispatch) => {
    dispatch({ type: types.UPDATING_USER });
    try {
      const responseObj = { usersData: [user], isCreate: false };

      const response = await apiService.updateUsers(responseObj);

      const updatedUser = JSON.parse(_.get(response, 'data.rpcService').output);

      if (!updatedUser[0].isValid) {
        throw new Error('API Failed');
      }
      dispatch({ type: types.DELETE_USER_SUCCESS, user });
    } catch (e) {
      logUtils.logError(e, 'Delete User Failed');
      dispatch({ type: types.UPDATE_USER_FAILED });
      throw e;
    }
  };
}

export function getAssetbyId(id) {
  try {
    const res = apiService.getAssetByIds([id]);
    return res;
  } catch (error) {
    logUtils.logError(error, 'Stop details fetch failed');
    return [];
  }
}

export function onFieldChange(fieldList) {
  return (dispatch) => {
    dispatch({ type: types.ON_FIELD_CHANGE, selectedFieldList: fieldList });
  };
}

export function bulkUpdate(user, incorrectUsersfromfile) {
  const correctUsers = [];
  const incorrectUsers = [...incorrectUsersfromfile];
  let updatedUser = null;

  return async (dispatch, getState) => {
    dispatch({ type: types.BULK_CREATING_USER });
    try {
      const responseApi = await apiService.updateUsers(user);
      updatedUser = JSON.parse(_.get(responseApi, 'data.rpcService').output);

      updatedUser.forEach((response) => {
        if (response?.isValid) {
          correctUsers.push({ ...response.u, comments: 'SUCCESS' });
        } else {
          incorrectUsers.push({ ...response.user, comments: response.message });
        }
      });

      dispatch({
        type: types.BULK_CHECK_USER_SUCCESS,
        correctUsers: correctUsers || [],
        incorrectUsers: incorrectUsers || [],
      });
      if (!user.bulkCreate) {
        const { selectedFieldList } = getState().userManagementReducer.usersAtFieldLevel;

        const newCorrectUsers = [];
        correctUsers.forEach((correctUsersObj) => {
          if (
            selectedFieldList.includes(correctUsersObj.fieldId) ||
            selectedFieldList.includes('notassignedtofields')
          ) {
            newCorrectUsers.push(_.omit(correctUsersObj, 'comments'));
          }
        });
        dispatch({
          type: types.BULK_CREATE_USER_SUCCESS,
          correctUsers: newCorrectUsers || [],
          selectedFieldList,
        });
      }
      return updatedUser;
    } catch (e) {
      logUtils.logError(e, 'Bulk create User Failed');

      dispatch({ type: types.BULK_CREATE_USER_FAILED });
      throw e;
    }
  };
}

export function updatePassword(password, user) {
  return async (dispatch) => {
    dispatch({ type: types.UPDATING_USER });
    try {
      const data = { id: _.get(user, 'id'), password, userName: _.get(user, 'userName') };
      const updatedUserbefore = { ...data };

      const USER = { usersData: [updatedUserbefore], isCreate: false, changePassword: true };

      const response = await apiService.updateUsers(USER);
      const updatedUser = JSON.parse(_.get(response, 'data.rpcService').output);
      if (!updatedUser) throw new Error('API Failed');
      dispatch({ type: types.UPDATE_USER_SUCCESS });
      return true;
    } catch (e) {
      logUtils.logError(e, 'Password update failed');
      dispatch({ type: types.UPDATE_USER_FAILED });
      return false;
    }
  };
}

export function updateUser(user) {
  let updatedUser = null;
  let succes = false;
  return async (dispatch) => {
    dispatch({ type: types.UPDATING_USER });
    try {
      const response = await apiService.updateUsers(user);

      updatedUser = JSON.parse(_.get(response, 'data.rpcService').output);
      succes = _.get(response, 'data.rpcService.success');

      if (!_.get(response, 'data.rpcService.success')) {
        throw new Error('API Failed');
      }
      if (!updatedUser[0].isValid) {
        throw new Error('API Failed');
      }
      const updated = updatedUser.map((res) => res.u);

      dispatch({
        type: types.USER_UPDATE_INFO,
        users: updated,
      });
      return updated;
    } catch (e) {
      if (!succes) {
        logUtils.logError(e);
        toastr.error('API failed');
      } else if (user?.isCreate) {
        logUtils.logError(e, `Create User Failed. ${updatedUser[0].message}`);
      } else {
        logUtils.logError(e, `Update User Failed. ${updatedUser?.[0]?.message ?? ''}`);
      }
      dispatch({ type: types.UPDATE_USER_FAILED });
      throw e;
    }
  };
}

export function clearedituserInfo() {
  return async (dispatch) => {
    try {
      dispatch({ type: types.CLEAR_EDIT_USER_INFO });
    } catch (error) {
      logUtils.logError(error, "Couldn't fetch teams data");
    }
  };
}

export function loadTeamList(fieldIds) {
  return async (dispatch) => {
    try {
      dispatch({ type: types.TEAM_LIST_LOADING_START });
      const reqfieldIds = fieldIds.filter((val) => val !== 'all-fields' && val !== 'notassignedtofields');
      const promises = [];
      for (const fieldId of reqfieldIds) {
        const params = Utility.getSearchGraphQLParamForFieldId(fieldId);
        promises.push(apiService.searchTeams(params));
      }
      const response = await Promise.all(promises);
      const teams = response.flatMap((r) => r?.data?.searchTeams?.items ?? []);

      dispatch({ type: types.TEAM_LIST_LOADING_DONE, teams });
      return teams;
    } catch (error) {
      logUtils.logError(error, "Couldn't fetch teams data");
      dispatch({ type: types.TEAM_LIST_LOADING_STOP });
      return [];
    }
  };
}

export function loadAreaList(teamID) {
  return async (dispatch) => {
    try {
      dispatch({ type: types.AREA_LIST_LOADING_START });
      const response = await apiService.getAreasByTeams(teamID);
      const areas = response.data.getAreasByTeams;

      dispatch({ type: types.AREA_LIST_LOADING_DONE, areas });
    } catch (error) {
      logUtils.logError(error, "Couldn't fetch teams data");
      dispatch({ type: types.AREA_LIST_LOADING_STOP });
    }
  };
}

export async function getAllUsers(apiFunction, selectedFields, dispatch, ...apiArgs) {
  let nextToken = null;
  let totalCount = 0;
  do {
    const response = await apiFunction(...apiArgs, nextToken);
    const users = _.get(response, `data.searchUsers.items`);
    dispatch({ type: types.LOAD_USERS_AT_FIELD_LEVEL_SUCCESS, users, selectedFieldList: selectedFields });
    nextToken = response.data.searchUsers.nextToken;
    totalCount = parseInt(_.get(response, `data.searchUsers.total`, 0));
  } while (nextToken && nextToken < totalCount);
}

export function startLoading() {
  return async (dispatch) => {
    dispatch({ type: types.LOADING_STATE_ACTIVE, loadingState: true });
  };
}

export function stopLoading() {
  return async (dispatch) => {
    dispatch({ type: types.LOADING_STATE_INACTIVE, loadingState: false });
  };
}

export function fetchUsers(data, param) {
  return async (dispatch, getState) => {
    let output = [];

    try {
      const { fieldArray, selectedVendor = '' } = data;
      if (!_.isEmpty(fieldArray)) {
        const apiParam = { fieldIds: fieldArray, size: 50, selectedVendor };
        if (_.size(param.filterModel)) {
          apiParam.filters = _.clone(param.filterModel);
        }
        if (_.size(param.sortModel)) {
          apiParam.sort = _.clone(param.sortModel);
        }
        const { items = [] } = getState().userManagementReducer.usersAtFieldLevel;

        const { startRow: startRowInReducer } = getState().userManagementReducer.gridParam;
        const { startRow } = param;
        const showNextPage = startRow > startRowInReducer;
        if (showNextPage) {
          const reqUser = items[items.length - 1];
          if (reqUser) {
            apiParam.nextToken = [new Date(reqUser.modifiedOn).getTime(), reqUser.id];
          }
        }

        output = await apiService.getUsersByCustomFilters(apiParam);
        dispatch(setUserList(output));
        dispatch(setGridParam(param));
      }
      return output;
    } catch (e) {
      console.error(e);
      setUserList([{}]);
    } finally {
      // setUserList([{}]);
    }
    return output;
  };
}
export function loadMultipleUserManagement(selectedFields) {
  const params = Utility.getSearchgraphQLformultiplefieldId(selectedFields);
  console.log('🚀 ~ file: actions.js ~ line 316 ~ loadMultipleUserManagement ~ params', params);

  return async (dispatch) => {
    dispatch({ type: types.LOADING_USERS_AT_FIELD_LEVEL });
    try {
      await getAllUsers(getUsersApi, selectedFields, dispatch, params);
    } catch (e) {
      logUtils.logError(e, "Couldn't fetch user list");
      dispatch({ type: types.LOAD_USERS_AT_FIELD_LEVEL_FAILED });
    }
  };
}

export function loadUsersForField(selectedField) {
  const { id: fieldId } = selectedField;
  const params = Utility.getSearchGraphQLParamForFieldId(fieldId);
  return async (dispatch) => {
    dispatch({ type: types.LOADING_USERS_AT_FIELD_LEVEL });
    try {
      await getAllUsers(getUsersApi, null, params);
    } catch (e) {
      logUtils.logError(e, 'Users Loading Failed');
      dispatch({ type: types.LOAD_USERS_AT_FIELD_LEVEL_FAILED });
    }
  };
}

export function loadPickLists(pickListType) {
  const pickListName = `PICKLIST_${pickListType}_NAME`;
  const pickListLoadingType = types[`LOADING_${pickListType}_PICKLIST`];
  const pickListSuccessType = types[`LOAD_${pickListType}_PICKLIST_SUCCESSFUL`];
  const pickListFailureType = types[`LOAD_${pickListType}_PICKLIST_FAILED`];

  return async (dispatch) => {
    const params = {
      filter: {
        name: {
          eq: constants[pickListName],
        },
      },
    };
    dispatch({ type: pickListLoadingType });
    try {
      const response = await apiService.searchPicklist(params);
      const pickLists = response.data.searchPicklists && response.data.searchPicklists.items;
      if (!pickLists || pickLists.length === 0) {
        // eslint-disable-next-line no-throw-literal
        throw { message: `${constants[pickListName]} list is not found` };
      }
      const options = pickLists[0].options ? JSON.parse(pickLists[0].options) : {};
      const pickListOptions = getPickListOptions(Object.values(options));

      dispatch({ type: pickListSuccessType, pickListOptions });
    } catch (e) {
      const message = e instanceof Error ? `${pickListType} List Failed` : e.message;
      logUtils.logError(e, message);
      dispatch({ type: pickListFailureType });
    }
  };
}

export function loadUsersSubscription({ updatedUser }) {
  return async (dispatch, getState) => {
    try {
      const { loggedInUser } = getState().appReducer;
      // updated user belong to the selected Area required in future
      const vendorId = _.get(loggedInUser, 'vendorId');
      const updatedUservenorId = _.get(updateUser, 'vendorId');

      if ((vendorId && updatedUservenorId && vendorId === updatedUservenorId) || !vendorId) {
        dispatch({ type: types.LOAD_TASK_USERS_SUBSCRIPTION_SUCCESS, updatedUser });
      }
    } catch (e) {
      console.error(e);
      dispatch({ type: types.LOAD_USERS_AT_FIELD_LEVEL_FAILED });
    }
  };
}

export function exportUserList(data, columns) {
  return async (dispatch) => {
    let output = '';
    dispatch(setIsExporting(true));
    try {
      const { fieldArray = [], vendorId = '', teamsMap = {}, filters = {} } = data;

      if (!_.isEmpty(fieldArray)) {
        const apiParam = { fieldIds: fieldArray, vendorId, teamsMap, columns, isAllData: true };
        if (_.size(filters)) {
          apiParam.filters = _.clone(filters);
        }
        output = await apiService.exportAllUsers(apiParam);
      }
      return output;
    } catch (e) {
      console.error(e);
      setUserList([{}]);
    } finally {
      dispatch(setIsExporting(false));
    }
    return output;
  };
}
